import React from 'react'
import { isEarlyReader } from '../../../../services/EarlyReaderService';
import ReportPrintHeader from '../../../Teacher/Reports/ReportPrintHeader';
import ProgressReport from '../../blocks/Charts/Progress';
import useReportSelections from '../../util/useReportSelections';

/**
 * takes a report object and renders a report
 * @returns 
 */
export default function ProgressReportBatchPrintRenderer(props) {

    const { report, i } = props
    const { benchmark, equating, customBenchmarks, locale, selectedStatePercentileCuts } = useReportSelections();

    if (!report) return null
    if (!report.progressReport) return null
    if (!report.progressReport.data) return null
    if (!report.progressReport.data.length && !report.progressReport.armScore) return null

    const {progressReport, student} = report
    const notEarlyReaderCount = progressReport.data.filter(studentData => !isEarlyReader(studentData)).length;

    return (
        <div className='progress-batch-print-page'>
            {report.student && <ReportPrintHeader title={`Progress Report for ${student.label}`} />}
            <ProgressReport key={i}
                report={progressReport}
                onClick={() => { }}
                selectedBenchmark={benchmark}
                customBenchmarks={customBenchmarks}
                selectedEquating={equating}
                notEarlyReaderCount={notEarlyReaderCount}
                selectedLocale={locale}
                selectedStatePercentileCuts={selectedStatePercentileCuts}
            />
        </div>
    )
}
